<template>
	<div class="section-map"> 
		<v-img :src="ImageMap" />
		<!-- <p class="text-h3 primary--text my-5 text-center">Легенда карты</p> -->
		<div class="px-3 pt-6 px-sm-5 d-flex justify-space-between legend primary--text font-weight-bold">
			<div>
				<div>1. Ванильный крутиш</div>
				<div>2. Московские сосиски</div>
				<div>3. У Аннушки</div>
				<div>4. Бабл - вафли</div>
			</div>

			<div>
				<div>5. Кукисы печем</div>
				<div>6. Кренделя и Чебуреки</div>
				<div>7. Пончики</div>
				<div>8. Братья цыплята</div>
			</div>

			<div>
				<div>9. Осетинские пироги</div>
				<div>10. Русские пряники</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
	name: 'SectionMap',
	data: () => ({
		ImageMap: require('@/assets/images/2025/map.png'),
	}),
});
</script>

<style lang="less" scoped>
.section-map {
	.legend {
		gap: 8px;

		& > div {
			flex: 1;
		}
	};
	border-radius: 24px;
	overflow: hidden;	
}

@media (max-width: 600px) {
	.section-map {
		div {
			font-size: 12px;
		}
	}
}
</style>
